import httpServe from './http'
let commonSercive = {}

/**
 * 字典码查询
 * @param code
 * @returns {Promise.<void>}
 */
commonSercive.getCode = async function (code) {
  let url = httpServe.getApiUrl('/pub/loadcode?groups=' + code)
  let res = await httpServe.ajaxGet(url, {}, true)
  return res['data']
}

/**
 * 公共批量修改状态
 * @param code
 * @returns {Promise.<void>}
 */
commonSercive.setStatus = async function (params) {
  let url = httpServe.getUms('/api/page/batchSetStatus')
  let res = await httpServe.ajaxPost(url, params, true)
  return res['data']
}

/**
 * 公共批量公共修改状态
 * @param code
 * @returns {Promise.<void>}
 */
commonSercive.setCompanyStatus = async function (params) {
  let url = httpServe.getUms('/api/company/setCompanyStatus')
  let res = await httpServe.ajaxPost(url, params, true)
  return res['data']
}


/**
 * 网店系统查询
 * @param code
 * @returns {Promise.<void>}
 */
commonSercive.web_site = async function () {
  let res = await this.getCode('WebSystemCode')
  return res
}

/**
 * 商户模板
 * @param code
 * @returns {Promise.<void>}
 */
commonSercive.getMbsList = async function (code) {
  let url = httpServe.getUms('/api/site/findEnableSiteTemplate')
  let res = await httpServe.ajaxPost(url, {siteTypeCode: code}, true)
  return res['data']
}

// 获取所有菜单权限
commonSercive.queryAuths = async function () {
  let url = httpServe.getApiUrl('/api/auth/findAuths')
  let res = await httpServe.ajaxPost(url,{applicationId: 1} ,true)
  return res['data']
}
// 获取菜单权限
commonSercive.queryUserAuths = async function () {
  let url = httpServe.getApiUrl('/api/auth/findUserAuth')
  let res = await httpServe.ajaxGet(url, {},true)
  return res['data']
}
// 退出登录
commonSercive.logout = async function (access_token, refresh_token) {
  let params = {
      access_token: access_token,
      refresh_token: refresh_token
  }
  let url = httpServe.getApiUrl('/pub/user/logout');
  let res = await httpServe.ajaxGet(url, {},true)
  return res['data'];
}

// 获取商品类目
commonSercive.findCategory = async function () {
  let url = httpServe.getOms('/api/listing/findCategory')
  let res = await httpServe.ajaxGet(url, {},true)
  return res['data']
}

export default commonSercive
